// This file is generated by the openedx/frontend-platform's "intl-import.js" script.
//
// Refer to the i18n documents in https://docs.openedx.org/en/latest/developers/references/i18n.html to update
// the file and use the Micro-frontend i18n pattern in new repositories.
//

// Skipped import due to missing 'paragon/index.js' likely due to empty translations..
// Skipped import due to missing 'frontend-platform/index.js' likely due to empty translations..
// Skipped import due to missing 'frontend-app-authn/index.js' likely due to empty translations..

export default [

];
